import React from 'react';
import { Path } from 'web-common/src/shared/design-system/Utilities/SVG';
import { BaseIcon16, BaseSVGProps } from '../BaseIcon';

export interface SVGProps extends BaseSVGProps {}

export interface BaseIconProps extends SVGProps {
  path: string;
}

export const BaseProteinIcon: React.FC<BaseIconProps> = (props) => {
  const { path, ...otherProps } = props;
  return (
    <BaseIcon16 {...otherProps}>
      <Path d={path} />
    </BaseIcon16>
  );
};
